module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/fancy-box/fancy-box-thumbnail/fancy-box-thumbnail.component.scss
// module id = ./src/app/features/fancy-box/fancy-box-thumbnail/fancy-box-thumbnail.component.scss
// module chunks = main